import ProductVariantNameBox from 'common/product-variant-name-box/ProductVariantNameBox';

const RenderProductsArray = ({ data = [], productsToShow = 2 }) => {
  return (
    <div data-tag="allowRowEvents">
      <ProductVariantNameBox
        productVariants={data}
        productsToShow={productsToShow}
        dropdownTrigger={['hover']}
        attachDropdownToBody
      />
    </div>
  );
};

export default RenderProductsArray;
